module.exports = __webpack_public_path__ + "de26f9b6bd28ffe4432ed15e853dba88.pdf";